export default __webpack_public_path__ + "static/media/xnxx.927b07b2.jpg";